import React, { useEffect, useState } from 'react';
import { PageWrapper } from '@/common/styles/Wrappers';
import ValidInvoicesSearchBar from './components/validInvoicesSearchBar/ValidInvoicesSearchBar';
import ValidInvoicesTable from './components/validInvoicesTable/ValidInvoicesTable';
import { useRequestsContext } from '@/common/hooks/requestHook';
import {
	acceptCorrectionInvoice,
	acceptValidInvoice,
	deleteInvoiceById,
	generateCorrectionInvoicePreview,
	generateValidInoicePreview,
	getValidInvoiceCorrectionsByStatus,
	getValidInvoices,
	updateCorrectionInvoice,
	updateValidInvoiceTicket,
} from '@/API/repositories/tickets';
import Loading from '@/common/components/Loading';
import { getCompanies } from '@/API/repositories/company';
import { preventFn } from '@/common/functions/preventEvent';
import { getFileById } from '@/API/repositories/storedDocument';
import ConfirmDialog from './components/validInvoicesTable/components/confirmDialog/ConfirmDialog';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';

const ValidInvoices = () => {
	const [validInvoicesTickets, setValidInvoicesTickets] = useState();
	const [visibleTickets, setVisibleTickets] = useState();
	const [selectedStatus, setSelectedStatus] = useState();
	const [selectedMarket, setSelectedMarket] = useState();
	const [selectedTicket, setSelectedTicket] = useState();
	const [selectedCompany, setSelectedCompany] = useState();
	const [toDelete, setToDelete] = useState();
	const [allMarketsChecked, setAllMarketsChecked] = useState(false);

	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const handleSearch = async (e) => {
		e && preventFn(e);

		const payload = {};

		payload.marketId = selectedMarket.value;
		payload.status = selectedStatus.value;
		payload.companyId = selectedCompany.value;

		const response = await makeRequest(getValidInvoices.bind(null, payload));

		if (!response?.data) {
			setValidInvoicesTickets(() => null);
			setSelectedTicket(() => null);
			return;
		}

		setValidInvoicesTickets(() => response.data);
		setSelectedTicket(() =>
			response.data.find((ticket) => ticket._id === selectedTicket?._id),
		);
	};

	const handleSearchCorrectionsByStatus = async (e) => {
		e && preventFn(e);
		const response = await makeRequest(
			getValidInvoiceCorrectionsByStatus.bind(null, selectedStatus.value),
		);

		if (!response?.data) {
			setValidInvoicesTickets(() => null);
			setSelectedTicket(() => null);
			return;
		}

		setValidInvoicesTickets(() => response.data);
		setSelectedTicket(() =>
			response.data.find((ticket) => ticket._id === selectedTicket?._id),
		);
	};

	const resetData = () => {
		setSelectedTicket(() => null);
		setValidInvoicesTickets(() => null);
	};

	const handleDeleteInvoice = async () => {
		setToDelete(null);

		const response = await makeRequest(
			deleteInvoiceById.bind(null, toDelete._id),
		);
		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}

		setSelectedTicket(() => null);
		await handleSearch();
	};

	useEffect(() => {
		resetData();
	}, [selectedMarket, selectedStatus]);

	return (
		<PageWrapper>
			{hasUnfilledRequest(
				getValidInvoices,
				updateValidInvoiceTicket,
				generateValidInoicePreview,
				acceptValidInvoice,
				getFileById,
				updateCorrectionInvoice,
				generateCorrectionInvoicePreview,
				acceptCorrectionInvoice,
				getCompanies,
			) && <Loading />}
			<ValidInvoicesSearchBar
				validInvoicesTickets={validInvoicesTickets}
				setVisibleTickets={setVisibleTickets}
				selectedStatus={selectedStatus}
				setSelectedStatus={setSelectedStatus}
				handleSearch={handleSearch}
				selectedMarket={selectedMarket}
				setSelectedMarket={setSelectedMarket}
				handleSearchCorrectionsByStatus={handleSearchCorrectionsByStatus}
				selectedCompany={selectedCompany}
				setSelectedCompany={setSelectedCompany}
				allMarketsChecked={allMarketsChecked}
				setAllMarketsChecked={setAllMarketsChecked}
			/>
			{!!validInvoicesTickets?.length && (
				<ValidInvoicesTable
					selectedTicket={selectedTicket}
					setSelectedTicket={setSelectedTicket}
					setToDelete={setToDelete}
					handleSearch={
						allMarketsChecked ? handleSearchCorrectionsByStatus : handleSearch
					}
					selectedStatus={selectedStatus}
					tickets={visibleTickets}
				/>
			)}
			{toDelete && (
				<ConfirmDialog
					text='Are you sure you want to delete this invoice?'
					onClose={() => setToDelete(null)}
					onConfirm={handleDeleteInvoice}
				/>
			)}
		</PageWrapper>
	);
};

export default ValidInvoices;
